import axios from 'axios';
import md5 from 'md5';
import { extraFileName } from '@/utils';

export class MiniFont {
  /** 每种字体的字符串对应md5值 */
  fontMapTextMd5: Record<string, string> = {};
  /** 正在请求中的字体集合 */
  fetchingFont: Set<string> = new Set();
  /**
   * 测试发现有些字体进行压缩服务之后，字体渲染会有问题
   * 暂时跳过这些字体的子集化
   */
  tempSkipFontmin: string[] = ['SourceHanSerifCN-Heavy'];

  /**
   * 字符串去重
   */
  getNoDuplicateText(str: string): string {
    return Array.from(new Set(str))
      .sort()
      .join('')
      .replace(/\n|\r|\f|\v|\t|（|）|《|》|—|-/g, '');
  }

  /**
   * 获取子集化字体
   * @param fontFamily - 字体名称（带文件后缀）
   * @param textStr - 需要提取的字符
   * @param skipFontmin - 是否取消压缩字体服务
   *   2024.9.2 为解决部分字体压缩保存不一样问题，暂时取消英文字体压缩，直接保存整个字体包
   */
  getMiniFont(fontFamily: string, textStr: string, skipFontmin = false): Promise<Blob | void> {
    const fontName = extraFileName(fontFamily, false);

    if (skipFontmin || this.tempSkipFontmin.includes(fontName)) {
      return Promise.reject();
    }
    const familyWithoutSuffix =
      fontFamily.indexOf('.') !== -1 ? fontFamily.slice(0, fontFamily.indexOf('.')) : fontFamily;

    if (this.fetchingFont.has(familyWithoutSuffix) || !textStr || textStr.length === 0) {
      return Promise.resolve();
    }

    this.fetchingFont.add(familyWithoutSuffix);
    // 字符串去重
    // 加中文"一"的原因是如果使用了繁体字体，且该字体不包含任何textStr，会返回整个字体文件
    const noDuplicateText = this.getNoDuplicateText(textStr) + '一 0123456789.';
    const miniFontApi = 'https://www.xiuzhan365.com/fontmin';
    // const miniFontApi = 'http://192.168.2.215:3000'
    // const miniFontApi = 'http://192.168.2.245:3000'
    return axios
      .post<Blob>(
        miniFontApi,
        {
          text: noDuplicateText,
          fontFamily
        },
        {
          responseType: 'blob'
        }
      )
      .then((res) => {
        this.fontMapTextMd5[familyWithoutSuffix] = md5(noDuplicateText);
        return res.data;
      })
      .catch((err) => {
        throw err;
      })
      .finally(() => {
        this.fetchingFont.delete(familyWithoutSuffix);
      });
  }

  /**
   * 判断是否需要更新字体子集文件
   * @param fontFamily - 字体名字
   * @param textStr - 字体字符串
   */
  needToUpdateMiniFont(fontFamily: string, textStr: string): boolean {
    if (this.fontMapTextMd5[fontFamily]) {
      const noDuplicateText = this.getNoDuplicateText(textStr);
      const newTextMD5 = md5(noDuplicateText);
      if (newTextMD5 !== this.fontMapTextMd5[fontFamily]) {
        return true;
      }
      return false;
    }
    return true;
  }

  /**
   * 将字体md5信息更新到配置
   */
  updateFontMapText2Book(): void {}
}

export const miniFont = new MiniFont();
